export interface FileInputLabels {
  invalidFileTypeLabel: string;
  defaultMultipleDragLabel: string;
  defaultSingleDragLabel: string;
  defaultAltInstructionLabel: string;
  multipleFilesSelectedLabel: string;
  changeMultipleFilesLabel: string;
  singleFileSelectedLabel: string;
  changeSingleFileLabel: string;
}

export interface Translations {
  en: FileInputLabels;
  es: FileInputLabels;
}

const translations: Translations = {
  en: {
    invalidFileTypeLabel: 'This is not a valid file type.',
    defaultMultipleDragLabel: 'Drag files here or ',
    defaultSingleDragLabel: 'Drag file here or ',
    defaultAltInstructionLabel: 'choose from folder',
    multipleFilesSelectedLabel: 'files selected',
    changeMultipleFilesLabel: 'Change files',
    singleFileSelectedLabel: 'Selected file',
    changeSingleFileLabel: 'Change file',
  },
  es: {
    invalidFileTypeLabel: 'Este no es un tipo de archivo válido.',
    defaultMultipleDragLabel: 'Arrastre los archivos aquí o ',
    defaultSingleDragLabel: 'Arrastre el archivo aquí o ',
    defaultAltInstructionLabel: 'elegir de una carpeta',
    multipleFilesSelectedLabel: 'archivos seleccionados',
    changeMultipleFilesLabel: 'Cambiar archivos',
    singleFileSelectedLabel: 'Archivo seleccionado',
    changeSingleFileLabel: 'Cambiar archivo',
  },
};

export default translations;
